(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["category-engagement"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  if (window.bsCategoryMeasurement) return;
  var contextNode = document.getElementById('bs-category-context');
  if (!contextNode) return;
  var context;
  try { context = JSON.parse(contextNode.textContent); } catch (_) { return; }
  if (context.designMode) return;
  var measurementId = 'G-LNH66CE4EL';
  var key = 'bs_category_measurement_v1';
  var groups = {
    tiles: ['tiles', 'bathroom-tiles', 'kitchen-tiles', 'wall-tiles', 'floor-tiles', 'marble-effect-tiles', 'concrete-effect-tiles', 'large-format-tiles', 'large-format-120x60-tiles'],
    showers: ['all-showers', 'shower-enclosures', 'shower-doors', 'shower-trays', 'wet-room-shower-screens', 'thermostatic-showers-sets', 'sliding-shower', 'sliding-doors', 'hinged-showers', 'hinged-doors', 'bi-fold-showers', 'bi-fold-door', 'quadrant-shower-enclosures', 'corner-entry', 'frameless-shower-enclosures', 'frameless-shower-doors', 'concealed-shower-mixer-set', 'exposed-bar-shower', 'point-shower-sets', 'linear-drains', 'shower-tray-waste', 'shower-wastes'],
    furniture_basins: ['furniture-basins', 'vanity-units', 'basins', 'wall-hung-vanity-units', 'floor-standing-vanity-units', 'double-vanity-unit', 'oak-vanity-units-countertops', 'ceramic-basins', 'countertop-basins', 'mirrors', 'mirror-cabinets'],
    toilets: ['toilets', 'wall-hung-toilets', 'back-to-wall-toilets', 'close-coupled-toilets', 'toilet-packages', 'installation-frames-toilet-cisterns', 'flush-plate', 'bidets'],
    baths: ['baths', 'bath-tubs', 'freestanding-baths', 'inset-bath', 'back-to-wall-baths', 'bath-screens'],
    taps: ['taps', 'bathroom-taps', 'basin-taps', 'bath-taps', 'wall-mounted-bath-taps', 'thermostatic-taps', 'freestanding-bath-taps', 'kitchen-taps'],
    accessories: ['bathroom-accessories', 'towel-hanger', 'toilet-roll-holders', 'soap-dishes', 'soap-dispensers', 'toilet-brush-holders', 'bathroom-radiator']
  };
  function handleFrom(url) {
    try { return new URL(url, location.origin).pathname.match(/\/collections\/([^/]+)/)?.[1] || ''; } catch (_) { return ''; }
  }
  function groupFor(handle) {
    return Object.keys(groups).find(function (name) { return groups[name].indexOf(handle) !== -1; }) || '';
  }
  document.querySelectorAll('[data-bs-navigation-source] .nav__item').forEach(function (item) {
    var root = item.querySelector('a');
    var group = root && groupFor(handleFrom(root.href));
    if (!group) return;
    item.querySelectorAll('a[href]').forEach(function (link) {
      var handle = handleFrom(link.href);
      if (handle && !groupFor(handle)) groups[group].push(handle);
    });
  });
  var members = context.productCollections || [];
  var department = context.pageType === 'collection' ? groupFor(context.collection) : '';
  if (context.pageType === 'product') {
    var roots = {tiles:'tiles', showers:'all-showers', furniture_basins:'furniture-basins', toilets:'toilets', baths:'baths', taps:'taps', accessories:'bathroom-accessories'};
    department = Object.keys(roots).find(function (name) { return members.indexOf(roots[name]) !== -1; }) || '';
    if (!department && /^(tiles?|wall tiles?|floor tiles?)$/i.test(context.productType || '')) department = 'tiles';
    if (!department) department = members.map(groupFor).find(Boolean) || '';
  }
  var sessionId = '';
  var permitted = false;
  var started = false;
  var pendingSeconds = 0;
  var lastTick = performance.now();
  var lastSessionCheck = 0;
  var lastUrl = location.href;
  var dataLayerOffset = (window.dataLayer || []).length;
  var lastVisible = document.visibilityState === 'visible' && document.hasFocus();
  function allowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }
  function readState() {
    try {
      var stored = JSON.parse(localStorage.getItem(key));
      if (stored && stored.sessionId === sessionId && Date.now() - stored.updated < 1800000) return stored;
    } catch (_) {}
    return {sessionId: sessionId, updated: Date.now(), departments: {}};
  }
  function writeState(state) {
    state.updated = Date.now();
    try { localStorage.setItem(key, JSON.stringify(state)); } catch (_) {}
  }
  var volatileState;
  function stateFor() {
    var state = readState();
    if (!Object.keys(state.departments).length && volatileState && volatileState.sessionId === sessionId && Date.now() - volatileState.updated < 1800000) state = volatileState;
    if (!state.departments[department]) state.departments[department] = {seconds:0, products:[], visited:false, qualified:false};
    return state;
  }
  function send(name, params, targetDepartment) {
    if (!sessionId || !allowed() || typeof window.gtag !== 'function') return;
    window.gtag('event', name, Object.assign({
      send_to: measurementId,
      bs_department: targetDepartment || department || 'other',
      bs_page_kind: context.pageType,
      bs_measurement_version: '1',
      page_location: location.origin + location.pathname,
      transport_type: 'beacon'
    }, params));
  }
  function qualified(entry) {
    if (!entry.qualified && entry.seconds >= 60 && entry.products.length >= 3) {
      entry.qualified = true;
      send('bs_category_engaged', {bs_product_depth:entry.products.length});
    }
  }
  function startDepartment() {
    if (!department || started || !sessionId || !allowed()) return;
    started = true;
    var state = stateFor();
    var entry = state.departments[department];
    if (!entry.visited) {
      entry.visited = true;
      send('bs_category_visit', {bs_category_visits:1});
    }
    send('bs_category_page', {bs_collection:context.collection || ''});
    if (context.pageType === 'product' && context.productId && entry.products.indexOf(context.productId) === -1) {
      entry.products.push(context.productId);
      send('bs_product_explore', {bs_new_products:1, bs_product_depth:entry.products.length, bs_product_id:context.productId});
      if ([2,3,5].indexOf(entry.products.length) !== -1) send('bs_browse_' + entry.products.length + '_products', {});
    }
    qualified(entry);
    writeState(state);
    volatileState = state;
  }
  function flush() {
    if (!department || !started || !sessionId || !allowed()) { pendingSeconds = 0; return; }
    var seconds = Math.floor(pendingSeconds);
    if (!seconds) return;
    pendingSeconds -= seconds;
    var state = stateFor();
    var entry = state.departments[department];
    entry.seconds += seconds;
    send('bs_category_time', {bs_active_seconds:seconds});
    qualified(entry);
    writeState(state);
    volatileState = state;
  }
  function refreshSession() {
    if (!allowed() || typeof window.gtag !== 'function') return;
    lastSessionCheck = Date.now();
    window.gtag('get', measurementId, 'session_id', function (value) {
      if (!value || !allowed()) return;
      if (sessionId !== String(value)) {
        flush();
        sessionId = String(value);
        started = false;
        pendingSeconds = 0;
      }
      startDepartment();
    });
  }
  function tick() {
    var now = performance.now();
    var consent = allowed();
    var visible = document.visibilityState === 'visible' && document.hasFocus();
    if (consent && permitted && lastVisible && started) pendingSeconds += Math.min(Math.max((now-lastTick)/1000,0),5);
    lastTick = now;
    lastVisible = visible;
    if (!consent) {
      pendingSeconds = 0;
      started = false;
      sessionId = '';
      volatileState = null;
      if (permitted) { try { localStorage.removeItem(key); } catch (_) {} }
    }
    if (consent && (!permitted || !sessionId && Date.now()-lastSessionCheck >= 5000)) refreshSession();
    permitted = consent;
    var dataLayer = window.dataLayer || [];
    while (dataLayerOffset < dataLayer.length) {
      var item = dataLayer[dataLayerOffset++];
      if (department && item && item.event === 'add_to_cart_stape') send('bs_category_cart', {});
    }
    if (consent && visible && Date.now()-lastSessionCheck >= 60000) refreshSession();
    if (pendingSeconds >= 10 || !visible) flush();
    if (location.href !== lastUrl) {
      var oldUrl = new URL(lastUrl);
      var newUrl = new URL(location.href);
      lastUrl = location.href;
      if (department && oldUrl.pathname === newUrl.pathname && oldUrl.search !== newUrl.search) {
        var params = newUrl.searchParams;
        if (params.get('sort_by') !== oldUrl.searchParams.get('sort_by')) send('bs_category_sort', {bs_sort:params.get('sort_by') || 'default'});
        if (params.get('page') !== oldUrl.searchParams.get('page')) send('bs_category_paginate', {bs_page_number:Number(params.get('page') || 1)});
        var filters = function (url) { return Array.from(url.searchParams).filter(function (pair) { return pair[0].indexOf('filter.') === 0; }).sort().toString(); };
        if (filters(oldUrl) !== filters(newUrl)) send('bs_category_filter', {bs_filter_count:Array.from(params.keys()).filter(function (name) { return name.indexOf('filter.') === 0; }).length});
      }
    }
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || !allowed()) return;
    var target = new URL(link.href, location.origin);
    var menu = link.closest('nav, [data-bs-navigation-source], #bt-sidebar-nav, .mobile-nav, .bs-mobile-menu');
    var targetGroup = groupFor(handleFrom(link.href));
    if (menu && target.origin === location.origin && handleFrom(link.href)) {
      send('bs_menu_click', {bs_destination:target.pathname}, targetGroup || 'other');
    } else if (department && target.origin === location.origin && /\/products\//.test(target.pathname) && context.pageType === 'collection') {
      send('bs_product_click', {bs_destination:target.pathname});
    } else if (department && target.origin === location.origin && handleFrom(link.href)) {
      send('bs_category_navigate', {bs_destination:target.pathname});
    }
    if (department && (target.protocol === 'tel:' || target.protocol === 'mailto:' || /(^|\.)(wa.me|whatsapp.com)$/.test(target.hostname))) {
      send('bs_contact_click', {bs_contact_method:target.protocol === 'tel:' ? 'phone' : target.protocol === 'mailto:' ? 'email' : 'whatsapp'});
    }
    tick();
    flush();
  }, true);
  document.addEventListener('change', function (event) {
    if (department === 'tiles' && event.target.closest && event.target.closest('.tile-buy')) send('bs_tile_calculator', {});
  });
  document.addEventListener('visibilitychange', tick);
  document.addEventListener('visitorConsentCollected', tick);
  window.addEventListener('blur', tick);
  window.addEventListener('focus', tick);
  window.addEventListener('pagehide', function () { tick(); flush(); });
  window.addEventListener('pageshow', function (event) { if(event.persisted) { lastTick=performance.now(); lastVisible=false; tick(); } });
  window.setInterval(tick, 1000);
  window.bsCategoryMeasurement = {version:'1', department:department};
  tick();
})();
  } catch(e) { console.error(e); }
})();

})();
